module.exports = __webpack_public_path__ + "static/media/icon_profile.cbd34def.svg";